import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Services/TradeFinance/components/SectionContact/SectionContact.module.scss';

const cn = classNames.bind(styles);

const SectionContact = (): ReactElement => {
  return (
    <section className={cn('contact')}>
      <div className={cn('container')}>

        <div className={cn('contact__info')}>

          <div className={cn('contact__container')}>
            <h2 className={cn('contact__heading')}>
              Contact Us
            </h2>
            <p className={cn('contact__paragraph')}>
              For further information or to speak to a member of DP World Finance Trade
            </p>
          </div>

          <div className={cn('contact__container')}>
            <p className={cn('contact__paragraph')}>
              <span>Team call</span>:{' '}
              <a className={cn('contact__link')} href='tel:+97148259090'>+97148259090</a>
            </p>
            <p className={cn('contact__paragraph')}>
              <span>Email Global</span>:{' '}
              <a className={cn('contact__link')} href='mailto:global.tradefinance@dpworld.com'>global.tradefinance@dpworld.com</a>
            </p>
            <p className={cn('contact__paragraph')}>
              <span>Email UAE</span>:{' '} 
              <a className={cn('contact__link')} href='mailto:uae.tradefinance@dpworld.com'>uae.tradefinance@dpworld.com</a>
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SectionContact;